import React from 'react'

const LocationSeo = ({location}) => {
    const city = location?.address?.city || 'Amsterdam Diemen'
    const company = location?.company?.name || 'Autohopper'

    return (
        <div className="front-location-seo">
            <h2>Auto huren in {city}</h2>
            <p>
                Auto huren in {city}? Neem eens een kijkje bij {company} autoverhuur in {city}. De
                huurauto&apos;s uit onze vloot zijn allemaal nieuw en zijn van alles voorzien wat je nodig
                hebt om comfortabel en veilig op pad te gaan. De beschikbare huurauto&apos;s zijn vaak
                hooguit een jaar oud. {company} is de autoverhuurder met het meeste aantal vestigingen
                van Nederland. Daarom kunnen we de prijzen ook laag houden: onderaan de streep zijn wij
                vaak de voordeligste. Alle verplichte kosten zitten al bij de prijs in, de eerste 100
                kilometer per dag krijg je van ons. Het enige wat je nog moet betalen is de brandstof.
                Alle huurauto&apos;s zijn goed verzekerd en mocht er toch iets gebeuren dan kan je altijd
                terecht bij onze pechservice. Dus, auto huren in {city}? Hop hop, naar {company}!
            </p>

            <h3>Daarom kies je voor {company}</h3>
            <ul>
                <li>Nieuwe huurauto&apos;s van maximaal twee jaar oud</li>
                <li>Geen verborgen kosten</li>
                <li>Met meer dan 130 vestigingen de grootste autoverhuurder van Nederland</li>
            </ul>

            <h3>Busje huren in {city}</h3>
            <p>
                Wil je een busje huren in {city}, omdat je grote spullen moet vervoeren of binnenkort
                gaat verhuizen? Dat kan ook bij {company} autoverhuur in {city}. Kies voor een van de
                bestelbussen, bestelbusjes, verhuisbussen of bakwagens die wij beschikbaar hebben. Je
                kan rekenen op een nette bus die minimaal voorzien is van goed werkende airco en
                audio-installatie. Als je je verhuizing nog makkelijker wil maken, kies je voor de
                bestelbus met 20m3 laadruimte en elektrische laadlift. Je huurt alle busjes gemakkelijk
                met je B-rijbewijs. En... hop! Voor je het weet ben je weer lekker onderweg!
            </p>
        </div>
    )
}

export default LocationSeo
